var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeofenceEnbaledPurpleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12 22.2073V19.291",
    stroke: "#42296E",
    strokeWidth: 1.45812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 19.2902C16.0261 19.2902 19.2902 16.0261 19.2902 11.9996C19.2902 7.97311 16.0261 4.70898 11.9996 4.70898C7.97311 4.70898 4.70898 7.97311 4.70898 11.9996C4.70898 16.0261 7.97311 19.2902 11.9996 19.2902Z",
    stroke: "#42296E",
    strokeWidth: 1.45812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1.79297V4.70922",
    stroke: "#42296E",
    strokeWidth: 1.45812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.79297 12H4.70922",
    stroke: "#42296E",
    strokeWidth: 1.45812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2073 12H19.291",
    stroke: "#42296E",
    strokeWidth: 1.45812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 14.9165C13.6108 14.9165 14.9165 13.6108 14.9165 12.0002C14.9165 10.3896 13.6108 9.08398 12.0002 9.08398C10.3896 9.08398 9.08398 10.3896 9.08398 12.0002C9.08398 13.6108 10.3896 14.9165 12.0002 14.9165Z",
    stroke: "#42296E",
    strokeWidth: 1.45812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeofenceEnbaledPurpleIcon);
export default __webpack_public_path__ + "static/media/geofence_enbaled_purple_icon.79a6925e49b2fcd7e59e65a2058ced37.svg";
export { ForwardRef as ReactComponent };